namespace $ {

	type $shm_hitalama_compat_fqn_storage = {
		readonly length: number
		key( index: number ): string | null
		getItem( key: string ): string | null
		setItem( key: string, value: string ): void
	}

	const $shm_hitalama_compat_fqn_done = new WeakMap< object, Set< string > >
	const $shm_hitalama_compat_fqn_storage_done = new WeakSet< object >
	const $shm_hitalama_compat_fqn_prefixes = [
		{ current: '$shm_ba_', legacy: [ '$' + 'hitalama_ba_', '$shm_hitalama_ba_' ] },
		{ current: '$shm_wordstat_', legacy: [ '$' + 'hitalama_wordstat_', '$shm_hitalama_wordstat_' ] },
		{ current: '$shm_mentionstat_', legacy: [ '$' + 'hitalama_mentionstat_', '$shm_hitalama_mentionstat_' ] },
		{ current: '$shm_codex_', legacy: [ '$' + 'hitalama_codex_', '$shm_hitalama_codex_' ] },
		{ current: '$shm_check_', legacy: [ '$' + 'hitalama_check_', '$shm_hitalama_check_' ] },
		{ current: '$shm_duckdb', legacy: [ '$' + 'hitalama_duckdb', '$shm_hitalama_duckdb' ] },
		{ current: '$shm_period', legacy: [ '$' + 'hitalama_period', '$shm_hitalama_period' ] },
		{ current: '$shm_echarts', legacy: [ '$' + 'hitalama_echarts', '$shm_hitalama_echarts' ] },
		{ current: '$shm_hitalama_', legacy: [ '$' + 'hitalama_' ] },
	] as const

	function $shm_hitalama_compat_fqn_current( name: string ) {
		for( const mapping of $shm_hitalama_compat_fqn_prefixes ) {
			for( const legacy of mapping.legacy ) {
				if( name.startsWith( legacy ) ) return mapping.current + name.slice( legacy.length )
			}
		}
		return name
	}

	export function $shm_hitalama_compat_fqn_code( code: string, context: Record< string, any > = $ as any ) {
		const legacy_prefix = '$' + 'hitalama_'
		const legacy_pattern = new RegExp( '\\' + legacy_prefix + '[A-Za-z0-9_]+', 'g' )
		return code.replace( legacy_pattern, name => {
			const mapped = $shm_hitalama_compat_fqn_current( name )
			if( mapped !== name ) return mapped

			const suffix = name.slice( legacy_prefix.length )
			const shared = '$shm_' + suffix
			if( shared in context ) return shared

			return '$shm_hitalama_' + suffix
		} )
	}

	function $shm_hitalama_compat_fqn_storage_migrate( storage: $shm_hitalama_compat_fqn_storage | undefined ) {
		if( !storage || $shm_hitalama_compat_fqn_storage_done.has( storage ) ) return
		$shm_hitalama_compat_fqn_storage_done.add( storage )

		const keys = Array.from({ length: storage.length }, ( _, index )=> storage.key( index ) )
		for( const old_key of keys ) {
			if( !old_key ) continue
			const new_key = $shm_hitalama_compat_fqn_current( old_key )
			if( new_key === old_key ) continue
			if( storage.getItem( new_key ) !== null ) continue
			const value = storage.getItem( old_key )
			if( value !== null ) storage.setItem( new_key, value )
		}
	}

	export function $shm_hitalama_compat_fqn_install( context: Record< string, any > = $ as any ) {
		let done = $shm_hitalama_compat_fqn_done.get( context )
		if( !done ) $shm_hitalama_compat_fqn_done.set( context, done = new Set )

		for( const name of Object.keys( context ) ) {
			if( done.has( name ) ) continue
			// Mapping depends on the name, not its value. Framework names that
			// have no legacy alias must not repeat every prefix lookup on replay.
			done.add( name )
			const mapping = $shm_hitalama_compat_fqn_prefixes.find( mapping => name.startsWith( mapping.current ) )
			if( !mapping ) continue

			for( const prefix of mapping.legacy ) {
				const legacy = prefix + name.slice( mapping.current.length )
				if( legacy in context ) continue
				Object.defineProperty( context, legacy, {
					configurable: true,
					get: ()=> context[ name ],
					set: value => context[ name ] = value,
				} )
			}
		}

		const dom = globalThis as any
		$shm_hitalama_compat_fqn_storage_migrate( dom.localStorage )
		$shm_hitalama_compat_fqn_storage_migrate( dom.sessionStorage )
	}

	export function $shm_hitalama_compat_fqn_css( code: string ) {
		code = code
			.replaceAll( 'shm_hitalama_ba_app', 'shm_dashboard_app' )
			.replaceAll( 'hitalama_ba_app', 'shm_dashboard_app' )

		const prefixes = [
			[ 'shm_hitalama_ba_', 'shm_ba_' ],
			[ 'hitalama_ba_', 'shm_ba_' ],
			[ 'shm_hitalama_wordstat_', 'shm_wordstat_' ],
			[ 'hitalama_wordstat_', 'shm_wordstat_' ],
			[ 'shm_hitalama_mentionstat_', 'shm_mentionstat_' ],
			[ 'hitalama_mentionstat_', 'shm_mentionstat_' ],
			[ 'shm_hitalama_codex_', 'shm_codex_' ],
			[ 'hitalama_codex_', 'shm_codex_' ],
			[ 'hitalama_', 'shm_hitalama_' ],
		] as const

		for( const [ from, to ] of prefixes ) {
			code = code
				.replaceAll( `[${ from }`, `[${ to }` )
				.replace( new RegExp( `(^|[\\s,>+~])${ from }(?=[\\w-])`, 'gm' ), ( _, prefix )=> prefix + to )
		}
		return code
	}

}
